import { AccountType, LinkedRegistry, RegistryLinkStatus } from "../types/generated/graphql";
import { AggregatedRegistryCode } from "../types/okta.types";

export type SupportedLinkedRegistry = Omit<LinkedRegistry, "registryCode"> & {
  registryCode: AggregatedRegistryCode;
};

export function getRegistryCodeForTransactionFee(
  linkedRegistries: SupportedLinkedRegistry[] = [],
): AggregatedRegistryCode | undefined {
  const validLinkedRegistries = linkedRegistries.filter(
    (registry) => registry.status === RegistryLinkStatus.Registered,
  );

  if (!validLinkedRegistries?.length) return undefined;

  const hasRegistry = validLinkedRegistries.some((registry) => registry.accountType === AccountType.Registry);
  const hasNonRegistry = validLinkedRegistries.some((registry) => registry.accountType === AccountType.NonRegistry);

  // all are registry or mixed
  if ((hasRegistry && !hasNonRegistry) || (hasRegistry && hasNonRegistry)) {
    return validLinkedRegistries.find((registry) => registry.accountType === AccountType.Registry)?.registryCode;
  }

  // all are non-registry
  if (!hasRegistry && hasNonRegistry) {
    return validLinkedRegistries.find((registry) => registry.accountType === AccountType.NonRegistry)?.registryCode;
  }
}
